import { render } from "./AppPoweredBy.vue?vue&type=template&id=ae78162a"
import script from "./AppPoweredBy.vue?vue&type=script&lang=js"
export * from "./AppPoweredBy.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__